var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.714286,
    y: 0.714286,
    width: 38.5714,
    height: 38.5714,
    rx: 19.2857,
    transform: "matrix(-1 0 0 1 38.5714 0)",
    stroke: "#E0E0E2",
    strokeWidth: 1.42857
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2103_22504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.2857,
    height: 34.2857,
    transform: "matrix(-1 0 0 1 37.1426 2.85645)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2103_22504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3631 28.0764L18.8688 26.5271L13.4127 21.0711H30.7148V18.9282H13.4127L18.8688 13.4721L17.3631 11.9229L9.28627 19.9996L17.3631 28.0764Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.bf5e44fc17c59b906940181fb2a1726a.svg";
export { ForwardRef as ReactComponent };